import { BaseService } from './base.service';

export interface MembershipResponse {
  id: string;
  memberId: string;
  locationId: string;
  planId: string;
  plan?: {
    id: string;
    planId: string;
    name: string;
    slug: string;
    commitmentType: string;
    paymentTerm: number;
    billingCycle: string;
    price: number;
    minPrice: number;
    maxPrice: number;
    currency: string;
    status: string;
    planType?: string;
    /**
     * Admin-configured plan switches, keyed by `PlanField` on the API
     * (`box_assessment`, `elevated_coaching_session`,
     * `customized_improvement_plan`, `guest_access_free_count`,
     * `paid_guest_access`, `no_show_waiver_count`, `no_show_penalty`).
     *
     * `PlanDto` has always serialised this; the client type simply
     * never declared it. My Plan reads it to say what a membership
     * includes. A field counts as on only when `enabled` AND `value`
     * are both truthy — `enabled` alone means "configured", not
     * "granted".
     */
    fields?: Record<string, { value?: unknown; enabled?: boolean }>;
  };
  price: number;
  currency: string;
  term: number;
  planStartDate: string;
  startDate: string;
  endDate: string;
  /** When the next charge falls due. Distinct from `endDate`, which is
   *  when the term itself runs out. */
  nextBillingDate?: string;
  status: string;
  paidGuestAccessAllowed?: boolean;
}

export interface MembershipUsageResponse {
  totalFreeBookingCount: number;
  freeBookingsAvailed: number;
  paidBookingsCount: number;
  bookedCount: number;
  cancelledCount: number;
  noShowCount: number;
}

class MembershipService extends BaseService {
  constructor() {
    super('/memberships');
  }

  /**
   * Get current user's membership
   */
  async getMembership(): Promise<MembershipResponse> {
    return this.get<MembershipResponse>('');
  }

  /**
   * Get membership usage statistics
   */
  async getUsage(): Promise<MembershipUsageResponse> {
    return this.get<MembershipUsageResponse>('/usage');
  }
}

export const membershipService = new MembershipService();
export default membershipService;
